import React, { useState } from 'react';
import Modal from '../../../../../Components/Modal/Modal';
import { Size } from '../../../../../Enums/Size.enum';
import Text from '../../../../../Components/Base/Text/Text';
import Button from '../../../../../Components/Button/Button';
import { Theme } from '../../../../../Enums/Theme.enum';
// @ts-ignore
import styles from './ServiceScheduleNotificationModal.module.scss';
import LinkButton from '../../../../../Components/Button/LinkButton';
import Checkbox from '../../../../../Components/Base/Checkbox/Checkbox';
import { doNotShowHintAgain } from '../../../Services/manager.service';

interface Props {
	isOpened: boolean;
	onClose: () => void;
	onRedirect: () => void;
}

const ServiceScheduleNotificationModal: React.FC<Props> = ({
	isOpened,
	onClose,
	onRedirect,
}) => {
	const [doNotShowAgain, setDoNotShowAgain] = useState(false);

	const handleDoNotShowAgain = () => {
		if (doNotShowAgain) {
			doNotShowHintAgain('doNoShowServiceScheduleNotificationModal');
		}
	};

	const handleSetupServiceScheduleNow = () => {
		handleDoNotShowAgain();
		onRedirect();
		onClose();
	};

	const handleStayOnThisPage = () => {
		handleDoNotShowAgain();
		onClose();
	};

	return (
		<Modal opened={isOpened} onClose={onClose} size={Size.SM}>
			<Modal.Header
				title='component.serviceScheduleNotificationModal.title'
				firstUpper
			/>
			<Modal.Content contentScroll={true}>
				<div className={styles.wrapper}>
					<Text
						tx='component.serviceScheduleNotificationModal.text1'
						className={styles.textBold}
					/>
					<Text
						tx='component.serviceScheduleNotificationModal.text3'
						className={styles.textBold}
					/>
					<Text
						tx='component.serviceScheduleNotificationModal.text2'
						className='text-center'
					/>
					<Checkbox
						value={doNotShowAgain}
						onChange={() => setDoNotShowAgain(!doNotShowAgain)}
						tx='component.serviceScheduleNotificationModal.checkbox'
					/>
					<div className={styles.controls}>
						<LinkButton
							theme={Theme.BLUE}
							title='component.serviceScheduleNotificationModal.button1'
							onClick={handleStayOnThisPage}
						/>
						<Button
							theme={Theme.GREEN}
							title='component.serviceScheduleNotificationModal.button2'
							onClick={handleSetupServiceScheduleNow}
						/>
					</div>
				</div>
			</Modal.Content>
		</Modal>
	);
};

export default ServiceScheduleNotificationModal;
